import React from 'react';
import { FormattedMessage } from 'react-intl';
import { call } from './../utilities/http';
import {
    LOADING,
    COMPLETE,
    APPROVALS_GET_OK,
    APPROVALS_GET_SINGLE_OK,
    APPROVALS_APPROVE_IC_OK,
    APPROVALS_APPROVE_OK,
    APPROVALS_REJECT_OK,
    APPROVALS_RESET_OK,
    APPROVALS_GET_CONTRACTOR_OK
} from './types';
import { Snackbar } from '../components/snackbar';
import { jobStatus } from '../utilities/jobStatus';

const defaultState = {
    list: undefined,
    draft: undefined,
    contractor: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case APPROVALS_GET_OK:
            return { ...state, list: action.data };

        case APPROVALS_GET_SINGLE_OK:
            return { ...state, approval: action.data };

        case APPROVALS_APPROVE_OK:
        case APPROVALS_REJECT_OK:
            let approvals = state.list ? state.list.filter(a => a.id !== action.data.id) : [];
            return { ...state, list: [...approvals, action.data], draft: action.data };

        case APPROVALS_GET_CONTRACTOR_OK:
            return { ...state, contractor: action.data };

        case APPROVALS_APPROVE_IC_OK:
        default:
            return state;
    }
}

export function approveJob(job, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}/action/approve`, method: 'POST' })
            .then(response => {
                dispatch({ type: APPROVALS_APPROVE_OK, data: { ...job, ...response } });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function approveIC(job, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}/action/approveIC`, method: 'POST' })
            .then(response => {
                dispatch({ type: APPROVALS_APPROVE_IC_OK, data: { ...job, ...response } });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function rejectJob(job, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}/action/exception`, method: 'POST' })
            .then(response => {
                dispatch({ type: APPROVALS_REJECT_OK, data: { ...job, ...response } });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function resetJobOnboarding(job, icw2, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${job.id}/action/reset_${icw2}`, method: 'POST' })
            .then(response => {
                dispatch({ type: APPROVALS_RESET_OK, data: { ...job, ...response } });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getApprovals(role, onSuccess = response => null) {
    let { type, id } = role;
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/${type}/${id}/jobs?status=submitted&status=pending&extended=true` })
            .then(response => {
                const submitted = response ? response.filter(j => j.status === 'submitted') : [];
                const pendingIC = response ? response.filter(j => jobStatus(j) === 'ic-continue-request') : [];
                const pendingDontQualify = response ? response.filter(j => jobStatus(j) === 'dont-qualify-ic') : [];
                const approvals = [...submitted, ...pendingIC, ...pendingDontQualify];
                dispatch({ type: APPROVALS_GET_OK, data: approvals });
                dispatch({ type: COMPLETE });
                onSuccess(approvals);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.approvals'} defaultMessage={'Unable to retrieve approvals.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getApproval(id, onSuccess = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/job/${id}?extended=true` })
            .then(response => {
                dispatch({ type: APPROVALS_GET_SINGLE_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.approval'} defaultMessage={'Unable to retrieve approval.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getContractor(role, onSuccess = details => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        const { id, type } = role;
        if (!id || !type) {
            dispatch({ type: COMPLETE });
            return;
        }

        call({ path: `/${type}/${id}` })
            .then(response => {
                dispatch({ type: APPROVALS_GET_CONTRACTOR_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/approvals.jsx